import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminAttachmentTemplates } from '@/api/(admin)/attachment-templates';
import type { AdminAttachmentTemplate } from '@/api/(admin)/attachment-templates/types';
import type { AttachmentTemplatesQueryInput } from '../-types';
import {
  buildAttachmentTemplatesQs,
  toAttachmentTemplatesParams,
} from '../-utils/listParams';

/** Prefix for every cache entry on this screen, so one invalidation clears the list. */
export const adminAttachmentTemplatesQueryKey = [
  'admin',
  'attachmentTemplates',
] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function adminAttachmentTemplatesQueryOptions(
  input: AttachmentTemplatesQueryInput,
) {
  const params = toAttachmentTemplatesParams(input);
  return queryOptions({
    queryKey: [...adminAttachmentTemplatesQueryKey, 'list', params] as const,
    queryFn: () =>
      fetchAdminAttachmentTemplates(buildAttachmentTemplatesQs(params)),
  });
}

export function useAdminAttachmentTemplates(
  input: AttachmentTemplatesQueryInput,
) {
  const query = useQuery(adminAttachmentTemplatesQueryOptions(input));
  const rows: AdminAttachmentTemplate[] = query.data?.data ?? [];
  return { ...query, rows, totalCount: query.data?.meta.totalCount ?? 0 };
}
